import { render, staticRenderFns } from "./SuccessBackground.vue?vue&type=template&id=071990dd"
var script = {}
import style0 from "./SuccessBackground.vue?vue&type=style&index=0&id=071990dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports